module.exports = __webpack_public_path__ + "img/fee-template.7a438b05.png";